import { postHtmlRequest } from "../utils/fetch";
import { IBaseStepContentRequest } from "./content-service";
const basePath = "/apicore/stepsapi/";
export function getStepContent(
	productCategory: string,
	selectedAttributeValueMa: string[],
	stepIndex: number,
	optionGroup?: string,
	targetDeliveryDate?: string,
	theme?: string,
	predefinedProductName?: string,
): Promise<string> {
	const body = {
		pointOfSaleId: window.context.pointOfSaleId,
		language: window.context.language,
		productCategory: productCategory,
		selectedAttributeValueMa: selectedAttributeValueMa,
		stepIndex: stepIndex,
		predefinedProductName: predefinedProductName,
	} as IBaseStepContentRequest;
	if (optionGroup && optionGroup !== "undefined") body.optionGroup = optionGroup;
	if (targetDeliveryDate) body.targetDeliveryDate = targetDeliveryDate;
	if (theme) body.theme = theme;

	return postHtmlRequest<IBaseStepContentRequest>(basePath + "getstepcontent", body, {
		headers: new Headers({ "Content-type": "application/json; charset=utf-8" }),
	}).then() as Promise<string>;
}
